import httpClient from './httpClient';

export const BRAND_ENDPOINT = '/backoffice/brands';
export const getBrandListAPI = (params = {}) => httpClient.get(BRAND_ENDPOINT, { params });
